import React from "react";
import { beddowsToDecimal } from "../utils/lisk/utils/lisk/beddowsToDecimal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fromLiskEpoch } from "../utils/lisk/utils/lisk/time";
import moment from "moment";
import { Badge, Col, Row } from "reactstrap";

interface Props {
  blocks: any[];
}

export const BlockRow: React.FC<Props> = ({ blocks }) => {
  return (
    <Row>
      {blocks.map((block: any) => {
        return (
          <Col
            className="font-icon-list col-xs-6 col-xs-6"
            lg="2"
            md="3"
            sm="4"
            key={block.height}
          >
            <div className="font-icon-detail">
              <i className="tim-icons icon-app" />
              <p>
                <Badge
                  className={"badge-warning"}
                  style={{ fontSize: "medium" }}
                >
                  Height: {block.height}
                </Badge>{" "}
                <br />
                <Badge className={"badge-info"} style={{ fontSize: "larger" }}>
                  Forged by: {block.delegate.username}
                </Badge>
              </p>
            </div>
          </Col>
        );
      })}
    </Row>
  );
};
